// Partner referral slugs (lowercase) -> display name shown on the map page.
// Each new partner also needs adding to the API's SYH_REFERRAL_SOURCES allow-list.
const referralSources: { [slug: string]: string } = {
  'united-way': 'United Way',
};

export const getReferralSourceName = (slug?: string): string | undefined => {
  if (!slug) return undefined;
  const key = slug.trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(referralSources, key)
    ? referralSources[key]
    : undefined;
};

export default referralSources;
